import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {PurchaseOrderService} from 'app/blocks/service/api/purchase-order.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IPurchaseOrder, PurchaseOrder} from 'app/blocks/model/purchase-order.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class PurchaseOrderResource extends AbstractEntityResource<IPurchaseOrder> {
    constructor(purchaseOrderService: PurchaseOrderService, router: Router) {
        super(
            Resource.PURCHASE_ORDERS,
            purchaseOrderService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.PURCHASE_ORDERS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.PURCHASE_ORDERS),
            (entity?) => new PurchaseOrder(entity),
            (entity) => entity.purchaseOrderNo,
            'purchase_two'
        );
    }
}
